var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.25C17.59 11.25 17.25 10.91 17.25 10.5V8.5C17.25 5.35 16.36 3.25 12 3.25C7.64 3.25 6.75 5.35 6.75 8.5V10.5C6.75 10.91 6.41 11.25 6 11.25C5.59 11.25 5.25 10.91 5.25 10.5V8.5C5.25 5.6 5.95 1.75 12 1.75C18.05 1.75 18.75 5.6 18.75 8.5V10.5C18.75 10.91 18.41 11.25 18 11.25Z",
    fill: "#0D2645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.75C10.21 19.75 8.75 18.29 8.75 16.5C8.75 14.71 10.21 13.25 12 13.25C13.79 13.25 15.25 14.71 15.25 16.5C15.25 18.29 13.79 19.75 12 19.75ZM12 14.75C11.04 14.75 10.25 15.54 10.25 16.5C10.25 17.46 11.04 18.25 12 18.25C12.96 18.25 13.75 17.46 13.75 16.5C13.75 15.54 12.96 14.75 12 14.75Z",
    fill: "#0D2645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.25H7C2.59 23.25 1.25 21.91 1.25 17.5V15.5C1.25 11.09 2.59 9.75 7 9.75H17C21.41 9.75 22.75 11.09 22.75 15.5V17.5C22.75 21.91 21.41 23.25 17 23.25ZM7 11.25C3.42 11.25 2.75 11.93 2.75 15.5V17.5C2.75 21.07 3.42 21.75 7 21.75H17C20.58 21.75 21.25 21.07 21.25 17.5V15.5C21.25 11.93 20.58 11.25 17 11.25H7Z",
    fill: "#0D2645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.251c85289f56545277fa4950916cac66.svg";
export { ForwardRef as ReactComponent };